import React from 'react';
import './StrategyCompatibility.css';

const STATUS_LABELS: Record<string, string> = {
  available: 'Available',
  setup_required: 'Setup required',
  unavailable: 'Unavailable',
  unknown: 'Unknown',
};

type CompatibilityActionResult = {
  status: string;
  reason?: string | null;
};

type CompatibilityRequirement = {
  id: string;
  label: string;
  alternative?: string | null;
  statusByAction?: Record<string, CompatibilityActionResult | undefined>;
};

type CompatibilityAssessment = {
  requirements?: CompatibilityRequirement[];
} | null;

export default function StrategyCompatibility({
  assessment,
  action,
}: {
  assessment?: CompatibilityAssessment;
  action: string;
}) {
  const requirements = Array.isArray(assessment?.requirements)
    ? (assessment?.requirements ?? []).filter((item) => item?.statusByAction?.[action])
    : [];
  if (requirements.length === 0) return null;
  return (
    <section className="strategy-compatibility" aria-label={`${action} compatibility`}>
      <h2>Compatibility</h2>
      <div className="strategy-compatibility__items">
        {requirements.map((requirement) => {
          const result = requirement.statusByAction?.[action];
          if (!result) return null;
          return (
            <div className="strategy-compatibility__item" key={requirement.id}>
              <div className="strategy-compatibility__summary">
                <span>{requirement.label}</span>
                <span className={`strategy-compatibility__status strategy-compatibility__status--${result.status}`}>
                  {STATUS_LABELS[result.status] ?? 'Unknown'}
                </span>
              </div>
              {result.reason && <p>{result.reason}</p>}
              {requirement.alternative && <p>Alternative: {requirement.alternative}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
